export const telephonyDe = {
  admin: {
    title: 'Telefonie & KI-Schaltzentrale',
    subtitle:
      'Audio-Verarbeitung, Transkriptionsdienst, Sprachmodell und Freischaltung der Mitarbeiter.',
    tabEngine: 'Audio & KI-Engine',
    tabUsers: 'Benutzer-Freischaltung',
    error: 'Die Konfiguration konnte nicht geladen werden.',
    saved: 'Die Konfiguration wurde gespeichert.',
    engineTitle: 'Audio- & STT-Engine',
    engineHint:
      'Die Aufzeichnung wird nach dem Gespräch geladen, transkribiert und anschließend vom Sprachmodell ausgewertet.',
    enabled: 'KI-Auswertung aktiv',
    enabledHint: 'Ist die Auswertung abgeschaltet, werden Aufzeichnungen nur protokolliert.',
    mode: 'Audio-Verarbeitungsmodus',
    modeHint:
      'Die automatische Erkennung wählt anhand der Kanalzahl: Stereo wird kanalweise transkribiert, Mono über Sprecher-Diarisierung getrennt.',
    whisperUrl: 'Whisper- / WhisperX-API-URL',
    whisperKey: 'Whisper-Auth-Token',
    ollamaUrl: 'Ollama-Server-URL',
    ollamaUrlHint: 'Lokal „http://localhost:11434" oder im Netz „http://192.168.1.50:11434".',
    ollamaModel: 'Ollama-Modell',
    prompt: 'Extraktions-Prompt',
    promptHint:
      'Der Platzhalter {{transcript}} wird durch das formatierte Sprecher-Transkript ersetzt.',
    secretSet: 'Hinterlegt ({{hint}}). Leer lassen bewahrt den gespeicherten Wert.',
    secretUnset: 'Kein Token hinterlegt.',
  },
  modes: {
    AUTO_DETECT: 'Automatische Erkennung (Stereo → faster-whisper / Mono → WhisperX)',
    STEREO_SPLIT_FASTER_WHISPER: 'Erzwungen: Stereo-Dual-Channel (faster-whisper)',
    MONO_DIARIZATION_WHISPERX: 'Erzwungen: Mono-Sprecher-Diarisierung (WhisperX)',
    SINGLE_CHANNEL_PLAIN: 'Einfaches Mono ohne Sprecher-Trennung',
  },
  test: {
    title: 'Pipeline-Test',
    subtitle:
      'Testdatei hochladen und die gesamte Kette aus Formaterkennung, Transkription und Zusammenfassung prüfen.',
    upload: 'Testdatei hochladen & STT/LLM-Pipeline prüfen',
    running: 'Die Pipeline läuft. Je nach Länge der Aufnahme dauert das einige Minuten.',
    success: 'Die Pipeline ist vollständig durchgelaufen.',
    failed: 'Die Pipeline wurde mit einem Fehler beendet.',
    tooLarge: 'Die Testdatei ist größer als {{size}} MB.',
    transcript: 'Transkript',
    summary: 'Zusammenfassung',
    checkedAt: 'Geprüft am {{timestamp}}',
    steps: {
      ANALYSIS: 'Formaterkennung',
      TRANSCRIPTION: 'Transkription',
      SUMMARY: 'Zusammenfassung',
    },
  },
  users: {
    title: 'Freischaltung je Benutzer',
    subtitle:
      'Telefonie wird strikt pro Benutzerkonto aktiviert. Ohne Agent-ID, Direktwahl oder Durchwahl lassen sich eingehende Rufe nicht zuordnen.',
    error: 'Die Benutzerliste konnte nicht geladen werden.',
    empty: 'Es sind keine Benutzer vorhanden.',
    saved: 'Die Freischaltung wurde gespeichert.',
    user: 'Mitarbeiter',
    providerUserId: 'Agent-ID',
    providerUserIdHint: 'Ringover-Benutzerkennung, z. B. 1234567.',
    numbers: 'Rufnummern',
    extension: 'Interne Durchwahl',
    extensionPlaceholder: '101',
    directDial: 'Direktwahl (E.164)',
    directDialPlaceholder: '+4961421234512',
    outboundCallerId: 'Outbound CLI',
    outboundCallerIdPlaceholder: '+496142123450',
    outboundCallerIdHint: 'Rufnummer, die dem Angerufenen angezeigt wird.',
    apiKey: 'Persönlicher API-Key',
    apiKeyPlaceholder: 'Neuen Schlüssel eintragen',
    apiKeySet: 'Hinterlegt ({{hint}}). Leer lassen bewahrt den gespeicherten Wert.',
    apiKeyUnset: 'Kein Schlüssel hinterlegt.',
    showKey: 'Schlüssel anzeigen',
    hideKey: 'Schlüssel verbergen',
    enabled: 'Aktiv',
    toggle: 'Telefonie für {{name}} aktivieren',
    test: 'Testen',
    testHint: 'Verbindung mit den hinterlegten Zugangsdaten prüfen',
    testRunning: 'Der Verbindungstest läuft.',
    testSuccess: 'Verbindung steht: {{name}}',
    testSuccessAnonymous: 'Die Verbindung zum Anbieter besteht.',
    providerHint: 'Unterstützte Anbieter: {{providers}}.',
  },
  webhook: {
    title: 'Ringover Webhook-Endpunkt',
    hint: 'Trage diese URL und das Secret im Ringover Developer Dashboard ein, um Anruf-Events und Aufzeichnungen in Echtzeit zu empfangen.',
    url: 'Webhook-URL',
    copy: 'Kopieren',
    copied: 'Die Webhook-URL wurde kopiert.',
    copyFailed: 'Die URL konnte nicht kopiert werden. Bitte manuell markieren.',
    secret: 'Globales Webhook-Secret',
    secretPlaceholder: 'Neues Secret eintragen',
    secretHint:
      'Signaturschlüssel aller eingehenden Zustellungen. Er gilt für die gesamte Installation, weil Ringover je Integration genau ein Secret verwendet.',
    secretSet: 'Hinterlegt ({{hint}}). Leer lassen bewahrt den gespeicherten Wert.',
    secretUnset: 'Noch kein Secret hinterlegt — eingehende Zustellungen werden abgewiesen.',
    masterKey: 'Ringover Admin-API-Key (optional)',
    masterKeyHint: 'Wird für installationsweite Abfragen verwendet und ist nicht zwingend nötig.',
    save: 'Speichern',
    saved: 'Die Anbieterkonfiguration wurde gespeichert.',
    error: 'Die Anbieterkonfiguration konnte nicht geladen werden.',
  },
  list: {
    subtitle: 'Telefonate dieses Geschäftspartners mit Transkript und KI-Auswertung.',
    error: 'Die Gesprächshistorie konnte nicht geladen werden.',
    emptyTitle: 'Noch keine Telefonate erfasst',
    emptyHint: 'Sobald ein Gespräch geführt wurde, erscheint es hier.',
    selectHint: 'Wählen Sie ein Gespräch aus, um die Auswertung zu sehen.',
    showTranscript: 'Transkript anzeigen',
    callNow: '{{number}} anrufen',
    noPermission: 'Für die Gesprächshistorie fehlt die Berechtigung.',
  },
  fields: {
    startedAt: 'Zeitpunkt',
    direction: 'Richtung',
    agent: 'Mitarbeiter',
    status: 'Status',
    duration: 'Dauer (Min.)',
    actions: 'Aktionen',
  },
  directions: {
    INBOUND: 'Eingehend',
    OUTBOUND: 'Ausgehend',
  },
  statuses: {
    RINGING: 'Klingelt',
    ANSWERED: 'Angenommen',
    MISSED: 'Verpasst',
    VOICEMAIL: 'Mailbox',
    FAILED: 'Fehlgeschlagen',
  },
  sentiments: {
    POSITIVE: 'Positiv',
    NEUTRAL: 'Neutral',
    NEGATIVE: 'Negativ',
    DISPUTED: 'Konflikt',
  },
  processing: {
    PENDING: 'Die Auswertung ist eingeplant.',
    DOWNLOADING_AUDIO: 'Die Aufzeichnung wird geladen …',
    TRANSCRIBING: 'Das Gespräch wird transkribiert …',
    SUMMARIZING: 'Das Sprachmodell fasst zusammen …',
    COMPLETED: 'Auswertung abgeschlossen.',
    FAILED: 'Die Auswertung ist fehlgeschlagen.',
    DISABLED: 'Die KI-Auswertung ist systemweit abgeschaltet.',
  },
  summary: {
    title: 'KI-Zusammenfassung',
    empty: 'Für dieses Gespräch liegt keine Zusammenfassung vor.',
    edit: 'Zusammenfassung bearbeiten',
    editorLabel: 'Zusammenfassung',
    saved: 'Die Zusammenfassung wurde gespeichert.',
    editedBadge: 'Bearbeitet von {{name}} am {{timestamp}}',
    showOriginal: 'Original-KI-Text anzeigen',
    actionItems: 'Aufgaben',
    reprocess: 'Auswertung erneut starten',
    reprocessStarted: 'Die Auswertung wurde erneut gestartet.',
  },
  transcript: {
    title: 'Gesprächstranskript',
    subtitle: 'Verarbeitungsmodus: {{mode}}',
    modeUnknown: 'unbekannt',
    empty: 'Für dieses Gespräch liegt kein Transkript vor.',
    showPlain: 'Als Fließtext',
    showDialog: 'Als Dialog',
    agent: 'Mitarbeiter',
    customer: 'Kunde',
  },
  screenPop: {
    title: 'Eingehender Anruf',
    unknown: 'Zu dieser Rufnummer ist kein Geschäftspartner hinterlegt.',
    openDocuments: '{{count}} offene Belege',
    lastCall: 'Letztes Gespräch: {{timestamp}}',
    open: 'Kontakt öffnen',
    blockedTitle: '🚨 Gesperrt: {{status}}',
    blockedReason: 'Grund: {{reason}}',
  },
  call: {
    started: 'Der Anruf wurde gestartet. Bitte nehmen Sie ihn am Endgerät an.',
    failed: 'Der Anruf konnte nicht gestartet werden: {{message}}',
  },
} as const;
